export default "__VITE_ASSET__DiQa1zxT__"